import { Card, Flex, Spin, Table, TableProps, Typography } from "antd";
import { Availability } from "../../../api/slowboatApi";
import { useGetInventoryOverviewQuery } from "../../../api/inventory/inventoryApi";

const columns: TableProps<Availability>["columns"] = [
  {
    title: "SKU",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Quantity",
    dataIndex: "count",
    key: "count",
    render: (count: number) => count === 0 ? "Out of Stock" : count
  }
]

export default function InventoryCard() {
  const { data, error, isFetching } = useGetInventoryOverviewQuery();

  console.log("inv card data", data);

  const sortedData = data?.toSorted((a, b) => a.title.localeCompare(b.title)) || [];

  return (
    <Card title="Inventory" style={{ width: "100%", height: "100%" }}>
      { isFetching &&
        <Flex justify="center" align="center" style={{ height: "100%" }}>
          <Spin />
        </Flex>
      }
      { error && <Typography.Text>Error loading inventory status</Typography.Text> }
      { data && !isFetching &&
        <Table<Availability>
          columns={columns}
          dataSource={sortedData}
          rowKey="id"
          pagination={false}
          size="small"
          style={{ flex: 1 }}
        />
      }
    </Card>
  )
}